import React from 'react';
import { View, Image, Pressable, StyleSheet } from 'react-native';
import { COLOR, COLOR_DARKEST } from '../../constants/styles';

const styles = StyleSheet.create({
  menuButton: {
    width: 50,
    height: 50,
    borderRadius: 50,
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: 'white',
    shadowOpacity: 1,
    shadowRadius: 8,
    shadowColor: 'rgba(0, 0, 0, .15)',
    shadowOffset: { height: 3, width: 0 },
    elevation: 2,
  },
  addIcon: {
    tintColor: COLOR.emphasis,
    width: 23,
    height: 23,
    resizeMode: 'contain',
  },
});

function PlusButton(props) {
  const { onPress, source, children, buttonStyle, iconStyle } = props;
  if (children) {
    return (
      <Pressable style={[styles.menuButton, buttonStyle]} onPress={onPress}>
        {children}
      </Pressable>
    );
  }

  return (
    <Pressable style={[styles.menuButton, buttonStyle]} onPress={onPress}>
      <Image
        style={iconStyle || styles.addIcon}
        source={source || require('../../../resources/icon-add.png')}
        resizeMode="contain"
      />
    </Pressable>
  );
}

export default PlusButton;
